// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"9f0fa8ed","239":"303d779c","455":"0f145644","683":"dc847b77","806":"4b080e9b","977":"fda976b1"}[chunkId] + ".chunk.js";
};